import React, {Component} from 'react';
import HYTradeCount from "./HYTradingActivity/HYTradeCount";
import HYTradeCountShare from "./HYTradingActivity/HYTradeCountShare";
import HYTradeVolume from "./HYTradingActivity/HYTradeVolume";
import HYTradeVolumeShare from "./HYTradingActivity/HYTradeVolumeShare";

class HYTradingActivity extends Component {
    state = {
        selectedChart: 0
    };

    render() {
        return (
            <React.Fragment>
                {this.state.selectedChart === 0 && (
                    <HYTradeCount/>
                )}
                {this.state.selectedChart === 1 && (
                    <HYTradeCountShare/>
                )}
                {this.state.selectedChart === 2 && (
                    <HYTradeVolume/>
                )}
                {this.state.selectedChart === 3 && (
                    <HYTradeVolumeShare/>
                )}
                <ul style={{textAlign: 'center', margin: '5px 0 0 0', padding: 0}}>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 0 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 0})}>
                            Trade Count
                        </button>
                    </li>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 1 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 1})}>
                            Trade Count Share
                        </button>
                    </li>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 2 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 2})}>
                            Trade Volume
                        </button>
                    </li>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 3 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 3})}>
                            Trade Volume Share
                        </button>
                    </li>
                </ul>
            </React.Fragment>
        );
    }
}

export default HYTradingActivity;



// WEBPACK FOOTER //
// ./frontend/components/Charts/MarketInsights/HYTradingActivity.jsx